import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'debtor-relations',
    name: 'DebtorRelations',
    component: () => import('~/views/debtors/DebtorRelations.vue'),
    meta: { title: 'Работа с должниками' }
  },
  // References
  {
    path: 'debtor-relations/houses-of-debtors',
    name: 'HousesOfDebtors',
    component: () => import('~/views/debtors/lists/references/HousesOfDebtors.vue'),
    meta: { title: 'Дома для работы с должниками' }
  },

  {
    path: 'debtor-relations/houses-of-debtors/detail/:id?',
    name: 'HouseOfDebtors',
    component: () => import('~/views/debtors/list-items/references/HouseOfDebtors.vue'),
    meta: { title: 'Дом для работы с должниками' }
  },

  {
    path: 'debtor-relations/debtor-templates',
    name: 'DebtorTemplates',
    component: () => import('~/views/debtors/lists/references/DebtorTemplates.vue'),
    meta: { title: 'Шаблоны' }
  },

  {
    path: 'debtor-relations/debtor-templates/detail/:id?',
    name: 'DebtorTemplate',
    component: () => import('~/views/debtors/list-items/references/DebtorTemplate.vue'),
    meta: { title: 'Шаблон' }
  },

  {
    path: 'debtor-relations/debt-cases-pre-trial-works-types',
    name: 'DebtCasesPreTrialWorksTypes',
    component: () => import('~/views/debtors/lists/references/DebtCasesPreTrialWorksTypes.vue'),
    meta: { title: 'Виды комментариев по досудебной работе' }
  },

  {
    path: 'debtor-relations/debt-cases-pre-trial-works-types/detail/:id?',
    name: 'DebtCasesPreTrialWorksType',
    component: () => import('~/views/debtors/list-items/references/DebtCasesPreTrialWorksType.vue'),
    meta: { title: 'Вид комментария по досудебной работе' }
  },

  {
    path: 'debtor-relations/judicial-sectors',
    name: 'JudicialSectors',
    component: () => import('~/views/debtors/lists/references/JudicialSectors.vue'),
    meta: { title: 'Судебные участки' }
  },

  {
    path: 'debtor-relations/judicial-sectors/detail/:id?',
    name: 'JudicialSector',
    component: () => import('~/views/debtors/list-items/references/JudicialSector.vue'),
    meta: { title: 'Судебный участок' }
  },

  {
    path: 'debtor-relations/claimants',
    name: 'Claimants',
    component: () => import('~/views/debtors/lists/references/Claimants.vue'),
    meta: { title: 'Взыскатели' }
  },

  {
    path: 'debtor-relations/claimants/detail/:id?',
    name: 'Claimant',
    component: () => import('~/views/debtors/list-items/references/ClaimantDetails.vue'),
    meta: { title: 'Взыскатель' }
  },

  {
    path: 'debtor-relations/claimants-types',
    name: 'ClaimantsTypes',
    component: () => import('~/views/debtors/lists/references/ClaimantsTypes.vue'),
    meta: { title: 'Типы взыскателей' }
  },

  {
    path: 'debtor-relations/claimants-types/detail/:id?',
    name: 'ClaimantsType',
    component: () => import('~/views/debtors/list-items/references/ClaimantsType.vue'),
    meta: { title: 'Тип взыскателя' }
  },

  {
    path: 'debtor-relations/users-for-debtors',
    name: 'UsersForDebtors',
    component: () => import('~/views/debtors/lists/references/UsersForDebtors.vue'),
    meta: { title: 'Пользователи для работы с должниками' }
  },

  {
    path: 'debtor-relations/users-for-debtors/detail/:id?',
    name: 'UserForDebtors',
    component: () => import('~/views/debtors/list-items/references/UserForDebtors.vue'),
    meta: { title: 'Пользователь для работы с должниками' }
  },

  {
    path: 'debtor-relations/debt-proceeding-stages',
    name: 'DebtProceedingStages',
    component: () => import('~/views/debtors/lists/references/DebtProceedingStages.vue'),
    meta: { title: 'Этапы работы' }
  },

  {
    path: 'debtor-relations/debt-proceeding-stages/detail/:id?',
    name: 'DebtProceedingStage',
    component: () => import('~/views/debtors/list-items/references/DebtProceedingStage.vue'),
    meta: { title: 'Этап работы' }
  },

  {
    path: 'debtor-relations/debtors-by-periods',
    name: 'DebtorsByPeriods',
    component: () => import('~/views/debtors/lists/reports/DebtorsByPeriods.vue'),
    meta: { title: 'Должники по периодам' }
  },

  // Debt cases

  {
    path: 'debtor-relations/auto-debt-case-dispatchers',
    name: 'AutoDebtCaseDispatchers',
    component: () => import('~/views/debtors/lists/debtCases/AutoDebtCaseDispatchers.vue'),
    meta: { title: 'Исполнители по делам должников' }
  },

  {
    path: 'debtor-relations/auto-debt-case-dispatchers/detail/:id?',
    name: 'AutoDebtCaseDispatcher',
    component: () => import('~/views/debtors/list-items/debtCases/AutoDebtCaseDispatcher.vue'),
    meta: { title: 'Исполнитель по делам должников' }
  },

  // {
  //   path: 'debtor-relations/company-profile',
  //   name: 'CompanyProfile',
  //   component: () => import('~/views/debtors/lists/generalReferences/CompanyProfile.vue'),
  //   meta: { title: 'Организации' }
  // },

  {
    path: 'debtor-relations/houses',
    name: 'DebtorRelationsHouses',
    component: () => import('~/views/debtors/lists/generalReferences/DebtorRelationsHouses.vue'),
    meta: { title: 'Дома' }
  },

  {
    path: 'debtor-relations/houses/detail/:id?',
    name: 'DebtorRelationsHouse',
    component: () => import('~/views/debtors/list-items/generalReferences/DebtorRelationsHouse.vue'),
    meta: { title: 'Дом' }
  },

  {
    path: 'debtor-relations/accounts',
    name: 'DebtorRelations.Accounts',
    component: () => import('~/views/debtors/lists/generalReferences/DebtorRelationsAccounts.vue'),
    meta: { title: 'Лицевые счета' }
  },

  {
    path: 'debtor-relations/accounts/detail/:id?',
    name: 'DebtorRelations.Account',
    component: () => import('~/views/debtors/list-items/generalReferences/DebtorRelationsAccount.vue'),
    meta: { title: 'Лицевой счет' }
  },
	{
    path: 'debtor-relations/accounts/fill-template-tko-accounts-processor',
    name: 'DebtorRelations.FillTemplateTKOAccountsProcessor',
    component: () => import('~/components/view/common/long-process/FillTemplateTKOAccountsProcessor.vue'),
    meta: { title: 'Выгрузить ЛС ТКО' }
  },
  {
    path: 'debtor-relations/accounts/accounts-csv-file-processor',
    name: 'DebtorRelations.AccountsCsvFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsCsvFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в CSV' }
  },
  {
    path: 'debtor-relations/accounts/accounts-excel-file-processor',
    name: 'DebtorRelations.AccountsExcelFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsExcelFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в Excel' }
  },
  {
    path: 'debtor-relations/accounts/create-cr-accounts-processor',
    name: 'DebtorRelations.CreateCRAccountsProcessor',
    component: () => import('~/components/view/common/long-process/CreateCRAccountsProcessor.vue'),
    meta: { title: 'Создать лицевые счета для кап.ремонта' }
  },
  {
    path: 'debtor-relations/accounts/account-from-tko-template-processor',
    name: 'DebtorRelations.AccountFromTkoTemplateProcessor',
    component: () => import('~/components/view/common/long-process/AccountFromTkoTemplateProcessor.vue'),
    meta: { title: 'Обновить ИЖКУ по результатам обработки шаблона ЛС ТКО' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/mobile-accounts-for-account',
    name: 'DebtorRelations.MobileAccountsForAccount',
    component: () => import('~/views/debtors/lists/generalReferences/MobileAccountsForAccount.vue'),
    meta: { title: 'Мобильные аккаунты' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/mobile-accounts-for-account/detail/:id?',
    name: 'DebtorRelations.MobileAccountForAccount',
    component: () => import('~/views/debtors/list-items/generalReferences/MobileAccountForAccount.vue'),
    meta: { title: 'Мобильный аккаунт' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/bills-for-account',
    name: 'DebtorRelations.BillsForAccount',
    component: () => import('~/views/debtors/lists/generalReferences/BillsForAccount.vue'),
    meta: { title: 'Квитанции' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/meters-for-account',
    name: 'DebtorRelations.MetersForAccount',
    component: () => import('~/views/debtors/lists/generalReferences/MetersForAccount.vue'),
    meta: { title: 'Приборы учета' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/notification-send-logs-for-account',
    name: 'DebtorRelations.NotificationSendLogsForAccount',
    component: () => import('~/views/debtors/lists/generalReferences/NotificationSendLogsForAccount.vue'),
    meta: { title: 'Логи уведомлений' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/claimants-for-account',
    name: 'DebtorRelations.ClaimantsForAccount',
    component: () => import('~/views/debtors/lists/generalReferences/ClaimantsForAccount.vue'),
    meta: { title: 'Взыскатели' }
  },
  {
    path: 'debtor-relations/accounts/detail/:parentId/claimants-for-account/detail/:id?',
    name: 'DebtorRelations.ClaimantForAccount',
    component: () => import('~/views/debtors/list-items/generalReferences/ClaimantForAccount.vue'),
    meta: { title: 'Взыскатель' }
  },

  {
    path: 'debtor-relations/payments-info',
    name: 'DebtorRelationsPaymentsInfo',
    component: () => import('~/views/debtors/lists/generalReferences/PaymentsInfo.vue'),
    meta: { title: 'Платежи' }
  },

  {
    path: 'debtor-relations/payments-info/detail/:id?',
    name: 'DebtorRelationsPaymentInfo',
    component: () => import('~/views/debtors/list-items/generalReferences/PaymentInfo.vue'),
    meta: { title: 'Платеж' }
  },

  {
    path: 'debtor-relations/bills',
    name: 'DebtorRelationsBills',
    component: () => import('~/views/debtors/lists/generalReferences/BillList.vue'),
    meta: { title: 'Квитанции' }
  },

  {
    path: 'debtor-relations/bills/detail/:id?',
    name: 'DebtorRelationsBill',
    component: () => import('~/views/debtors/list-items/generalReferences/DebtorRelationsBill.vue'),
    meta: { title: 'Квитанция' }
  },

  {
    path: 'debtor-relations/users',
    name: 'AccessUsers',
    component: () => import('~/views/debtors/lists/generalReferences/AccessUsers.vue'),
    meta: { title: 'Пользователи' }
  },

  {
    path: 'debtor-relations/users/detail/:id?',
    name: 'AccessUser',
    component: () => import('~/views/debtors/list-items/generalReferences/AccessUser.vue'),
    meta: { title: 'Пользователь' }
  },

  // Reports
  {
    path: 'debtor-relations/debtors-by-periods-report',
    name: 'DebtorsByPeriodsReport',
    component: () => import('~/views/debtors/reports/DebtorsByPeriodsReport.vue'),
    meta: { title: 'Отчет должники по периодам' }
  },
  {
    path: 'debtor-relations/claimants-report',
    name: 'ClaimantsReport',
    component: () => import('~/views/debtors/reports/ClaimantsReport.vue'),
    meta: { title: 'Отчет по взыскателям (оплатам) за период' }
  },
  {
    path: 'debtor-relations/debtor-cases-statuses-report',
    name: 'DebtorsCasesStatusesReport',
    component: () => import('~/views/debtors/reports/DebtorsCasesStatusesReport.vue'),
    meta: { title: 'Отчет по статусам работы с должниками' }
  },
  {
    path: 'debtor-relations/debtor-idents-statement-report',
    name: 'DebtorsIdentsStatementReport',
    component: () => import('~/views/debtors/reports/DebtorsIdentsStatementReport.vue'),
    meta: { title: 'База лицевых счетов (ведомость по должникам)' }
  },
  {
    path: 'debtor-relations/debtors-payment-report',
    name: 'DebtorsPaymentsReport',
    component: () => import('~/views/debtors/reports/DebtorsPaymentsReport.vue'),
    meta: { title: 'Оплата по должникам' }
  },
  {
    path: 'debtor-relations/debtors-informing-effectiveness-report',
    name: 'DebtorsInformingEffectivenessReport',
    component: () => import('~/views/debtors/reports/DebtorsInformingEffectivenessReport.vue'),
    meta: { title: 'Отчет по эффективности автообзвонов' }
  },  
  // Long process
  {
    path: 'debtor-relations/debtors-idents-statement-report-processor',
    name: 'DebtorsIdentsStatementReportProcessor',
    component: () => import('~/views/debtors/long-process/DebtorsIdentsStatementReportProcessor.vue'),
    meta: { title: 'База лицевых счетов (ведомость по должникам)' }
  },
  {
    path: 'debtor-relations/create-debt-cases-with-request-processor',
    name: 'CreateDebtCasesWithRequestProcessor',
    component: () => import('~/views/debtors/long-process/CreateDebtCasesWithRequestProcessor.vue'),
    meta: { title: 'Формирование дел должников' }
  },
  {
    path: 'debtor-relations/import-debtors-cases',
    name: 'ImportDebtorsCases',
    component: () => import('~/views/debtors/long-process/ImportDebtorsCases.vue'),
    meta: { title: 'Загрузка дел должников из файла' }
  },

  {
    path: 'debtor-relations/import-service-trial-balance-form-118-processor',
    name: 'ImportServiceTrialBalanceForm118Processor',
    component: () => import('~/views/debtors/long-process/ImportServiceTrialBalanceForm118Processor.vue'),
    meta: {
      title: 'Загрузка Оборотно-сальдовых ведомостей по услугам по форме 1.18'
    }
  },

  {
    path: 'debtor-relations/import-service-trial-balance-form-801006-processor',
    name: 'ImportServiceTrialBalanceForm801006Processor',
    component: () => import('~/views/debtors/long-process/ImportServiceTrialBalanceForm801006Processor.vue'),
    meta: {
      title: 'Загрузка Оборотно-сальдовых ведомостей по услугам по форме 80.10.06'
    }
  },

  {
    path: 'debtor-relations/import-service-trial-balance-form-bills-processor',
    name: 'ImportServiceTrialBalanceFormBillsProcessor',
    component: () => import('~/views/debtors/long-process/ImportServiceTrialBalanceFormBillsProcessor.vue'),
    meta: {
      title: 'Загрузка Оборотно-сальдовых ведомостей по услугам из квитанций'
    }
  },

  {
    path: 'debtor-relations/service-trial-balance',
    name: 'ServiceTrialBalance',
    component: () => import('~/views/debtors/lists/serviceTrialBalance/ServiceTrialBalance.vue'),
    meta: {
      title: 'Просмотр Оборотно-сальдовых ведомостей по услугам'
    }
  },

  {
    path: 'debtor-relations/service-trial-balance-report',
    name: 'ServiceTrialBalanceReport',
    component: () => import('~/views/debtors/reports/ServiceTrialBalanceReport.vue'),
    meta: {
      title: 'Отчет по оборотно-сальдовым ведомостям по услугам'
    }
  },

  {
    path: 'debtor-relations/debt-list',
    name: 'DebtList',
    component: () => import('~/views/requests-dispatcher/DebtList.vue'),
    meta: { title: 'Список дел должников' }
  },
  {
    path: 'debtor-relations/debt-list/detail/:id',
    name: 'DebtDetailItem',
    component: () => import('~/views/requests-dispatcher/DebtDetailItem.vue'),
    meta: {
      title: 'Дело должника',
    }
  },
];
